var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Pen = function Pen(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 14 14' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'pen'
      ),
      React.createElement('path', { d: 'M13.712 4.533L11.84 6.396l-4.28-4.26L9.43.271a.934.934 0 0 1 1.317 0l2.964 2.95a.926.926 0 0 1 0 1.311zm-7.043 7.01L0 13.923l2.389-6.64 3.854-3.836 4.28 4.26-3.854 3.836zm-3.9-2.57l-1.228 3.415 3.43-1.223L2.77 8.973z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Pen;
//# sourceMappingURL=Pen.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Pen.js